import * as React from "react";
import isEmpty from "lodash.isempty";
import { PersonDetailsProps } from "./person-details";
import { ProfilePictureName } from "../../page-framework/profile-picture-name";
import { SidebarLinks } from "../profile-details-tab/sidebar-links/sidebar-links";
import { ENTHUSIAST, INVESTOR, FOUNDER } from "../../../redux/authentication/account-types";
import { CreateCompanyButton } from "../../../modules/create-company/create-company-button";

export const SideBar = (props: PersonDetailsProps) => {
  const { person, user } = props;
  const isOwner = user && person && user?.id === person?.id;

  if (!person) {
    return <Container />;
  }

  // superPower is live in the API schema but not yet in the @radivision/graphql Person type.
  const superPower = (person as typeof person & { superPower?: string | null }).superPower;

  const accountType =
    person.accountType?.kind === ENTHUSIAST.kind
      ? "Community Member"
      : person.accountType?.kind === FOUNDER.kind
      ? "Founder"
      : person.accountType?.kind === INVESTOR.kind
      ? "Investor"
      : null;

  return (
    <Container>
      {accountType ? <h4>{accountType}</h4> : null}
      <h1>{person?.fullName}</h1>
      <article>{person?.responsibility}</article>
      {!isEmpty(superPower?.trim()) && (
        <div className="super-power">
          <h4>Super Power</h4>
          <article>{superPower}</article>
        </div>
      )}
      {isOwner && <CreateCompanyButton />}
      <a
        href={person?.websiteUrl?.includes("http") ? person?.websiteUrl : `//${person?.websiteUrl}`}
        className="website"
        rel="noreferrer"
        target="_blank"
      >
        {person?.websiteUrl}
      </a>
      <SidebarLinks subject={person} />
      {Array.isArray(person?.entities) && (
        <Companies>
          {person?.entities &&
            person.entities?.map((entity) => {
              return <ProfilePictureName subject={entity} key={`entity-${entity.id}`} />;
            })}
        </Companies>
      )}
    </Container>
  );
};

const Container = ({ children }: { children?: React.ReactNode }) => {
  return <div className="profile-sidebar">{children}</div>;
};
const Companies = ({ children }) => {
  return (
    <div className="company-list">
      <h4>Companies</h4>
      {children}
    </div>
  );
};
